import { Redirect } from '@shopify/app-bridge/actions';
import { getSABAppInstance_Normal, isByPassScript } from './app';

let SABRedirectInstance = null;

function createSABRedirectInstance() {
    const app = getSABAppInstance_Normal();
    SABRedirectInstance = Redirect.create(app);
}

export const shopifyRedirect = (url) => {
    if (isByPassScript()) {
        if (!SABRedirectInstance) {
            createSABRedirectInstance();
        }
        SABRedirectInstance.dispatch(Redirect.Action.REMOTE, url);
        return
    }

    window.open(url, '_top');
};

export const shopifyRedirectAdmin = (url) => {
    if (!SABRedirectInstance) {
        createSABRedirectInstance();
    }
    SABRedirectInstance.dispatch(Redirect.Action.ADMIN_PATH, {
        path: url,
        newContext: true,
    });
};